import { GridCellParams, GridTreeNode } from '@mui/x-data-grid-pro';
import { NxObject, NxObjectService } from '@warehouse/object-browser/core';

export function getLicensorCellClassName(params: GridCellParams<NxObject, any, any, GridTreeNode>): string {
	if (NxObjectService.isGrayedAndItalicized(params.row)) return 'inherited';
	return '';
}
